import BaseEventPayload from './BaseEventPayload';

export default class FullTextPdfEventPayload extends BaseEventPayload {
  constructor(data = {}, parentEventLog) {
    super(FullTextPdfEventPayload, data, parentEventLog);
    this.fullTextPdfUri = data.fullTextPdfUri;
  }
}
